import React from 'react';
import { Link } from 'react-router-dom';
import { getCategoryIcon } from './CategoryIcons';

import '../../css/home.css';

/*
 * The photo-card treatment, used only for categories that actually ship
 * artwork. Everything else renders as a CategoryTile — see
 * CategoryDiscoverySection. There is deliberately no stand-in image here: when
 * the 20 image-less categories were handed a shared generic photo they read as
 * duplicates of each other.
 */
function CategoryCard({ category, eager = false }) {
    if (!category) return null;

    const { name = 'Category', image, tagline, shopCount } = category;

    const hasShopCount = Number(shopCount) > 0;

    return (
        <Link
            to={`/marketplace/search?category=${encodeURIComponent(name)}`}
            className="im-cat"
        >
            <div className="im-cat__media">
                <img
                    src={image}
                    alt=""
                    /* The first row is above the fold, the rest are not. */
                    loading={eager ? 'eager' : 'lazy'}
                    decoding="async"
                    /* Images are hotlinked from Unsplash, which rate-limits by referrer. */
                    referrerPolicy="no-referrer"
                />
                {/* Fixed dark bottom-up scrim rather than the API's per-category
                    `gradient`: those values are opaque pastel tints authored for a
                    mix-blend-mode:multiply treatment, and as an overlay they hide
                    the photo completely. */}
                <span className="im-cat__scrim" />
                <span className="im-cat__icon">{getCategoryIcon(category, 24)}</span>
            </div>

            <div className="im-cat__body">
                <div>
                    {/* The full name, not the API's `shortName`: that field cuts at
                        the ampersand, which turns "Home & Kitchen" into "Home" and
                        "TV & Home Entertainment" into "TV". */}
                    <strong className="im-cat__name">{name}</strong>
                    {tagline && <span className="im-cat__tagline">{tagline}</span>}
                </div>

                {/* Only shown when the count is real. A "0 shops nearby" badge is
                    noise, and an invented one is worse. */}
                {hasShopCount && (
                    <span className="im-cat__badge">
                        {shopCount} {Number(shopCount) === 1 ? 'shop' : 'shops'} nearby
                    </span>
                )}
            </div>
        </Link>
    );
}

export default CategoryCard;
